import { axios } from '@/lib/axios';
import { useQuery } from 'react-query';

export type LibraryListFiltersV2 = {
    libraryType?: 'VIDEO' | 'TEXTBOOK' | 'CHAPTER';
    joveDomainId?: number;
    locale?: string;
};

export type LibraryListSortV2 = {
    field: string;
    direction: 'asc' | 'desc';
};

export type LibraryListRequestV2 = {
    page?: number;
    size?: number;
    search?: string;
    filters?: LibraryListFiltersV2;
    sort?: LibraryListSortV2;
};

export type LibraryQuizListResultV2 = {
    id: number;
    quiz: {
        id: number;
        uuid: string;
        title: string;
        status: string;
        no_of_questions?: number;
        created_at?: string;
    };
    filters: { subject_names?: string[]; collection_names?: string[] };
};

export type LibraryListResponseV2 = {
    total: number;
    page: number;
    size: number;
    results: LibraryQuizListResultV2[];
};

const listLibraryQuizzesV2 = (body: LibraryListRequestV2): Promise<LibraryListResponseV2> =>
    axios.post('/api/v2/admin/quiz/library/list', body);

export const useLibraryQuizListV2 = (params: LibraryListRequestV2) =>
    useQuery({
        queryKey: ['library-quiz-v2', params],
        queryFn: () => listLibraryQuizzesV2(params),
        keepPreviousData: true,
    });
